require('./hireNewCreditCardStep2.scss');

import React, { useEffect } from 'react';
import { i18n } from 'core/i18n';
import { DisclaimerPersonalInfo } from 'components/hire/cardViaT/disclaimerPersonalInfo/disclaimerPersonalInfo';
import DropdownAccounts from 'components/dropdownAccounts/dropdownAccounts';
import HireCardNameSelector from 'components/hire/hireCardNameSelector/hireCardNameSelector';
import ShippingAddress from 'components/commons/shippingAddress/shippingAddress';
import { LoadingSection } from 'commonsComponents/loadingSection';
import OKModal from 'commonsComponents/OKModal';
import {
    ACCOUNT_INTERVENTION_CO_OWNER,
    ACCOUNT_INTERVENTION_OWNER,
    ACCOUNT_INTERVENTION_REPRESENTATIVE,
    CHECKING_ACCOUNT_CODE,
    EURO_TEXT,
    SECOND_STEP,
    THIRD_STEP,
    VIRTUAL,
    VIA_T
} from 'constants/index';
import {
    ACCOUNTS_WITH_CHEQUES_OR_DEBITS_SUBTYPES
} from 'constants/accounts';
import { HIRE_CARD_OPEN_CREDIT } from 'constants/operationCodesAccounts';
import PersonalDataHelper from 'utilities/personalDataHelper';
import { isPrintOfficeMode } from 'utilities/contactCenter/printerHelper';

const { FormattedText, formatText } = i18n;
const { OKMessage } = require('commonsComponents/OKMessage');
const { OKLink } = require('commonsComponents/OKLink');

export const HireNewCreditCardStep2 = ({
    getBlockedAccounts,
    immAccounts,
    hireNewCreditCard,
    handleAccountChange,
    isInactiveAccountsEnabled,
    getContextTranslate,
    immHireCardNameSelector,
    immHireContactData,
    setShippingAddress,
    immShippingAddressList,
    getshippingAddressList,
    blockedAccountsSuccess,
    cardType,
    validateStep,
    setCloseModal,
    visibleStep,
    hasShippingAddress,
    immAddress,
    immProfile,
}) => {
    useEffect(() => {
        const isShippingAddressSuccess = immShippingAddressList.get('isSuccess');
        !blockedAccountsSuccess && getBlockedAccounts(immAccounts.get('byId').toList(), HIRE_CARD_OPEN_CREDIT)
        !isShippingAddressSuccess && getshippingAddressList()
    }, []);

    const filterAccounts = () => {
        const interventionTypes = [
            ACCOUNT_INTERVENTION_OWNER,
            ACCOUNT_INTERVENTION_CO_OWNER,
            ACCOUNT_INTERVENTION_REPRESENTATIVE
        ];
        const accountsIndexes = immAccounts.get('byOrder').filter(accountId =>
            // We remove the accounts that are not in euros
            immAccounts.getIn(['byId', accountId, 'balance', 'currency']) === EURO_TEXT
        ).filter(accountId =>
            // We remove the accounts that don't comply with the requisites of product type and subtype
            immAccounts.getIn(['byId', accountId, 'newProduct']) === String(CHECKING_ACCOUNT_CODE) &&
            ACCOUNTS_WITH_CHEQUES_OR_DEBITS_SUBTYPES.includes(immAccounts.getIn(['byId', accountId, 'accountType']))
        ).filter(accountId =>
            // We remove the accounts where the user is not the owner
            interventionTypes.includes(immAccounts.getIn(['byId', accountId, 'interventionType']))
        );

        // We return an array with the ids of the filtered accounts
        return accountsIndexes.toJS();
    }
    const immStep = hireNewCreditCard.getIn(['steps', __CONTACT_CENTER__ ? THIRD_STEP : SECOND_STEP]);
    const accountErrorMsgVisible = immStep.get('accountIsDirty') && !immStep.get('accountIsValid');
    const accountErrorMsg = formatText(getContextTranslate('step3SelectAccountError'));
    const accountLabel = formatText('hireCardVanity-hireCardVanity_step3SelectAccount');
    const isBlockedAccountsLoading = immAccounts.get('blockedAccountsLoading');
    const isShippingAddressFetching = immShippingAddressList.get('shippingAddressList');
    const showModal = hireNewCreditCard.get('showModal');
    const newShippingAddressValid = immHireContactData.get('isValid');

    const errorRedirectionUrl = true
    const handleContinueModal = () => {
        validateStep(visibleStep)
    }
    const handleCancelModal = () => {
        setCloseModal()
    }
    const handleToggleModal = () => {
        setCloseModal()
    }
    const buildAddressContent = () => {
        const shippingAddress = PersonalDataHelper.getHireFormattedShippingAddress(immShippingAddressList, immAddress.getIn(['country', 'value']))
        return (
            <section className="">
                <span>
                    {formatText('hireNewCreditCard-modalShippingAddressPartOne')}
                </span>
                <span className='hire-new-credit-card__modal-address'>{shippingAddress}</span>
                <span>
                    {formatText('hireNewCreditCard-modalShippingAddressPartTwo')}
                </span>

            </section>
        );
    }
    let addressContent = cardType !== 'virtual-credit' && buildAddressContent();
    return (
        <article className="hire-new-credit-card">
            <div className="hire-new-credit-card__step-title">
                <FormattedText
                    className="hire-card-neruda__step-title"
                    value={'hireCardNeruda-hireCardNeruda_step3Title'}
                />
                {__CONTACT_CENTER__ && (
                    <div className="message-container">
                        <OKMessage type={"informative"}>
                            <FormattedText value="cc_hireNewCreditCard-step1InfoAccount" className={"info-account-text"} />
                        </OKMessage>
                    </div>
                )}
                <DropdownAccounts
                    accountsIndexes={filterAccounts()}
                    currentAccountId={immStep.get('accountId')}
                    blockedAccountsIds={immAccounts.get('blockedAccountsIds')}
                    error={accountErrorMsgVisible}
                    errorMsg={accountErrorMsg}
                    immAccounts={immAccounts.get('byId')}
                    label={accountLabel}
                    loading={isBlockedAccountsLoading}
                    onAccountChange={handleAccountChange}
                    optionalElement={!__CONTACT_CENTER__ && !isPrintOfficeMode() && DisclaimerPersonalInfo()}
                    showAvailableBalance
                    showInactiveAccountsAsBlocked={isInactiveAccountsEnabled}
                />
            </div>
            <section className="quota-selector-slider-section">
            </section>
            {cardType !== VIRTUAL &&
                <>
                    {cardType !== VIA_T &&
                        <HireCardNameSelector
                            immHireCardNameSelector={immHireCardNameSelector}
                        />
                    }
                    <hr className="broker-alerts-config-phone__divider" />

                    {!!isShippingAddressFetching ?
                        <ShippingAddress
                            immShippingAddressList={immShippingAddressList}
                            setShippingAddress={setShippingAddress}
                            immHireContactData={immHireContactData}
                            infoBlock={true}
                        />
                        :
                        <LoadingSection />
                    }

                </>
            }
            {cardType === VIRTUAL &&
                <div className="col-sm-12">
                    <div className="hire-new-credit-card__info-container">
                        <OKMessage type="informative">
                            <FormattedText value={'hireCardNeruda-hireCardNeruda_disclaimerPersonalInfoMsgNeruda'} />
                            &nbsp;
                            <OKLink modifier="emphasize" to={formatText('hireCardNeruda-hireCardNeruda_disclaimerPersonalInfoLinkUrlNeruda')} target="_blank">
                                <FormattedText value={'hireCardNeruda-hireCardNeruda_disclaimerPersonalInfoLinkTextNeruda'} />
                            </OKLink>
                        </OKMessage>
                    </div>
                </div>

            }
            {showModal && newShippingAddressValid &&
                <OKModal
                    title={formatText('hireNewCreditCard-modalStep2Title')}
                    description={addressContent}
                    contentOverflow="auto"
                    footerType="navigation"
                    headerType="image"
                    isOpen={errorRedirectionUrl}
                    onCloseCallback={() => handleToggleModal()}
                    onPrimaryButtonClick={() => handleContinueModal()}
                    onSecondaryButtonClick={() => handleCancelModal()}
                    secondaryButtonText={formatText('buttonsActions-cancel')}
                    primaryButtonText={formatText('common-continue')}
                    titleAlignment="center"
                    descriptionAlignment="center"
                />
            }
        </article>
    );
};

